import { createAPIModule } from 'utility/redux/apiModuleHelpers';
// import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.storage.block.volume.create;

const {
	actions,
	reducer,
	sagas,
	additionalSagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORAGE_BLOCK_VOLUME_CREATE',
	method: 'POST',
	url: '/storage/block/volume/create.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, additionalSagas, selectors };
